<div class="padding-20 ui-g" *ngIf="show.form" id="emissionConditionsCouponForm">
  <br />
  <br />
  <div class="ui-g-12">
    <div class="ui-g ui-g-8">

      <!-- riga -->
      <div class="ui-g-6">
        <!-- combo modalità di inizio fruizione -->
        <app-form-fields #tipoSogliaEmissione data-testid="tipoSogliaEmissione"
          (fieldModelChange)="onChangeTipoSoglia($event)" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.tipo_soglia_emissione" [(fieldModel)]="fieldModel.tipoSogliaEmissione"
          [type]="'dropdown'" [placeholder]="'campaign.select_threshold_type_emission' | translate"></app-form-fields>

      </div>
      <div class="ui-g-4">
        <app-form-fields #sogliaEmissione data-testid="sogliaEmissione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.soglia_emissione_coupon" [(fieldModel)]="fieldModel.sogliaEmissione"
          [name]="'sogliaEmissione'" [type]="'number'"
          [placeholder]="'campaign.threshold_emission_coupon' | translate"></app-form-fields>

      </div>
      <div class="ui-g-2"></div>



    <!-- Accumulatori -->
      <div class="ui-g-12" *ngIf="!disabledSwitch.gestioneAccumulatori && isActionDynamic">
        <br />
        <br />

        <app-form-fields #switchGestioneAccumulatori data-testid="switchGestioneAccumulatori" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_gestione_accumulatori"
          (fieldModelChange)="onChangeGestioneAccumulatoriEmissione($event)"
          [(fieldModel)]="switch.gestioneAccumulatori"
          [ngClass]="{'notPermitted': formSchema.form.switch_gestione_accumulatori.disabled}"></app-form-fields>
      </div>

          <!-- Accumulatori da Movimentare-->
      <div class="ui-g-12 accumulatoriDaRiutilizzare"
        *ngIf="switch.gestioneAccumulatori && !disabledSwitch.gestioneAccumulatori && formSchema.form.accumulatori_operazione.visible && isActionDynamic">
        <br />
        <br />
        <div class="title">{{ 'campaign.accumulators_to_use' | translate }}</div>
        <br />
        <div class="listaAccumulatoriDaUtilizzare"
          *ngIf="fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length>0">
          <br />
          <table id="tableListaAccumulatori">
            <thead>
              <tr>
                <th><i class="pi pi-lock-open"></i></th>
                <th>{{ 'campaign.channel' | translate }}</th>
                <th>{{ 'campaign.accumulator' | translate }}</th>
                <th>{{ 'campaign.code' | translate }}</th>
                <th>{{ 'common.reason' | translate }}</th>
                <th>{{ 'campaign.value' | translate }}</th>
                <th>{{ 'campaign.operation' | translate }}</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let acm of fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare;let i=index;">
                <td><i *ngIf="!readOnly" class="fa fa-trash pointer" (click)="onDeleteAcmFromList(i)"></i></td>
                <td>{{acm.channelDescription}}</td>
                <td>{{acm.acmDescription}}</td>
                <td>{{acm.acm_code}}</td>
                     <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_causale"
                    #acm_reaspm data-testid="acm_reason" [placeholder]="'card.selectBlacklistReason' | translate"
                    [showLabel]="false" [(fieldModel)]="acm.c3AcmReason" [type]="'dropdown'" [options]="reasonItems"
                    [optionLabel]="'label'" [required]="true"   (fieldModelChange)="onReasonSelected($event, i)"></app-form-fields>

                </td>
                <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_valore" #acm_value
                    data-testid="acm_value" [(fieldModel)]="acm.c3AcmValue" [showLabel]="false"
                    [type]="'number'"[required]="true"></app-form-fields>
                </td>
          
                 <td>
                  <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_operazione"
                    #acm_operation data-testid="acm_operation" [placeholder]="'campaign.select_operation' | translate"
                    [showLabel]="false" [(fieldModel)]="acm.c3AcmOperation" [type]="'dropdown'" [required]="true"
                    (fieldModelChange)="onOperationSelected($event)"[disabled]="true"></app-form-fields>
                </td>
             
                 
          
              </tr>
            </tbody>
          </table>
          <br />
        </div>
        <div class="addButton" *ngIf="!readOnly">
          <div class="pointer fa fa-plus circleIcon" (click)="onClickAddAccumulatori()"></div>
          <span class="add-label">Aggiungi Accumulatore</span>
        </div>

          <div class="mode-toggle">
          <button [class.active]="selectedMode" (click)="selectedMode = true">
            Gestione Koncentro
          </button>
          <button [class.active]="!selectedMode" (click)="selectedMode = false">
            Gestione FE
          </button>
        </div>
      </div>




      <!-- Accumulatori da Controllare-->
      <div class="ui-g-12 accumulatoriDaRiutilizzare"
        *ngIf="switch.gestioneAccumulatori && !disabledSwitch.gestioneAccumulator && formSchema.form.accumulatori_regole_avanzate.visible  && isActionDynamic">
        <br />
        <br />
        <div class="title">{{ 'campaign.accumulators_rules' | translate }}</div>
        <br />

        <div class="and-or-toggle">
          <button [class.active]="useAnd" (click)="useAnd = true">
            AND
          </button>
          <button [class.active]="!useAnd" (click)="useAnd = false">
            OR
          </button>
        </div>
        <div class="listaAccumulatoriDaUtilizzare" *ngIf="fieldModel.gestioneAccumulatori.regoleAvanzate.length>0">
          <br />
          <table id="tableRegoleAvanzate">
            <thead>
              <tr>
                <th><i class="pi pi-lock-open"></i></th>
                <th>{{ 'campaign.channel' | translate }}</th>
                <th>{{ 'campaign.accumulator' | translate }}</th>
                <th>{{ 'campaign.code' | translate }}</th>
                <th>{{ 'campaign.operation' | translate }}</th>
                <th>{{ 'campaign.value' | translate }}</th>
 
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let acm of fieldModel.gestioneAccumulatori.regoleAvanzate;let i=index;">
                <td><i *ngIf="!readOnly" class="fa fa-trash pointer" (click)="onDeleteAcmFromRuleList(i)"></i></td>
                <td>{{acm.channelDescription}}</td>
                <td>{{acm.acmDescription}}</td>
                <td>{{acm.acm_code}}</td>
            <td>
              <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_regole_operatore" #acm_rule_operator
                data-testid="acm_rule_operator" [placeholder]="'campaign.select_operation' | translate" [showLabel]="false" [required]="true"
                [(fieldModel)]="acm.c3AcmRuleOperator" [type]="'dropdown'"></app-form-fields>
            </td>
            <td>
              <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.accumulatore_regole_valore" #acm_rule_value
                data-testid="acm_rule_value"  [required]="true" [(fieldModel)]="acm.c3AcmRuleValue" [showLabel]="false" [type]="'number'"></app-form-fields>
            </td>

              </tr>
            </tbody>
          </table>
          <br />
        </div>
        <div class="addButton" *ngIf="!readOnly">
          <div class="pointer fa fa-plus circleIcon" (click)="onClickAddAccumulatoriForRules()"></div>
          <span class="add-label">Aggiungi Regole Avanzate</span>
        </div>

      </div>
    </div>
    <div class="ui-g-4">
      <div class="articoloCouponBox ui-g ui-g-12"
        [ngClass]="{'notAvailableBarcode': !barcodeAvailable.articolo || show.mandatoryProduct }">
        <div class="ui-g-12 title">
          <span>{{ 'campaign.coupon_product' | translate }}</span>
        </div>
        <div class="ui-g-2">
          <div class="fa fa-search circleIcon"
            [ngClass]="{'notPermitted': (switch.soloBarcode || readOnly==true), 'pointer':  !switch.soloBarcode }"
            (click)="onClickSearchArticolo()"></div>
        </div>
        <div class="ui-g-10">
          <app-form-fields #articoloCoupon data-testid="articoloCoupon"  *ngIf="getProductOnlyBarcodeReady" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.articolo_coupon" (fieldModelChange)="onChangeArticoloCoupon($event)"
            (optionsDropdownChanged)="onOptionArticoloDropdownChanged($event)"
            (filterDropdownChanged)="onChangedFilterArticolo($event)"
            [serverOptions]="{service: srvCampaign3, methodName: 'getProductItemCompleteOnlyBarcodeAndId', filterField: 'description', groupByField: 'id', groupedFieldArray: {fieldName: 'barcode', newFieldName: 'barcodes'}}"
            [serverOptionsFilter]="this.messageInstanceObject.id"
            [showLabel]="false" [(fieldModel)]="fieldModel.articoloCoupon.articolo" [type]="'dropdown'"
            [optionLabel]="'description'" [placeholder]="'campaign.select_coupon_item' | translate"></app-form-fields>

        </div>
        <div class="ui-g-4">
          <app-form-fields #soloBarcode data-testid="soloBarcode" [label]="formSchema.form.solo_barcode.label[language]"
            [readOnly]="readOnly" (checkboxChanged)="onChangeSoloBarcode($event)" [(fieldModel)]="switch.soloBarcode"
            [type]="'checkbox'" [disabled]="formSchema.form.solo_barcode.disabled"
            [visible]="formSchema.form.solo_barcode.visible"></app-form-fields>
        </div>
        <div class="ui-g-8">
          <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.solo_barcode"
            *ngIf="soloBarcode.fieldModel" #soloBarcodeText data-testid="soloBarcodeText"
            [(fieldModel)]="fieldModel.barcodeManualCoupon" [showLabel]="false" [type]="'string'"></app-form-fields>
          <app-form-fields class="barcodeCouponTitle" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.barcode_coupon" *ngIf="!soloBarcode.fieldModel" #comboBarcodes
            data-testid="comboBarcodes" [optionLabel]="'barcode'" [(fieldModel)]="fieldModel.articoloCoupon.barcode"
            [type]="'dropdown'" [options]="comboBarcodes" [placeholder]="'xxxxxxxxxxxxxxxxx'"></app-form-fields>
        </div>
      </div>

      <div class="ui-g-12">
        <br />
        <br />
   
        <app-form-fields #switchBarcodeAttivatore data-testid="switchBarcodeAttivatore" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_barcode_attivatore"
          (fieldModelChange)="onChangeEmissioneBarcodeAttivatore($event)"
          [(fieldModel)]="switch.emissioneBarcodeAttivatore"></app-form-fields>
      </div>
      <div class="ui-g-12" *ngIf="switch.emissioneBarcodeAttivatore">
        <div class="articoloCouponAttivatoreBox ui-g ui-g-12"
          [ngClass]="{'notAvailableBarcode': !barcodeAvailable.articoloAttivatore }">
          <div class="ui-g-12 title">
            <span>{{ 'campaign.coupon_product_activator' | translate }}</span>
          </div>
          <div class="ui-g-2">
            <i class="fa fa-search circleIcon"
              [ngClass]="{'notPermitted': (switch.soloBarcodeAttivatore == true || readOnly==true), 'pointer':  switch.soloBarcodeAttivatore == false }"
              (click)="onClickSearchArticoloAttivatore()"></i>
          </div>
          <div class="ui-g-10">
            <app-form-fields #articoloCouponAttivatore data-testid="articoloCouponAttivatore" [showLabel]="false"
              [readOnly]="readOnly" [fieldSchema]="formSchema.form.articolo_coupon_attivatore"
              (fieldModelChange)="onChangeArticoloCouponAttivatore($event)"
              (optionsDropdownChanged)="onOptionArticoloAttivatoreDropdownChanged($event)"
              [(fieldModel)]="fieldModel.articoloCouponAttivatore.articolo"
              (filterDropdownChanged)="onChangedFilterArticoloAttivatore($event)"
              [serverOptions]="{service: srvCampaign3, methodName: 'getProductActivator', filterField: 'description', groupByField: 'id', groupedFieldArray: {fieldName: 'barcode', newFieldName: 'barcodes'}}"
              [optionLabel]="'description'"
              [placeholder]="'campaign.select_coupon_item_attivatore' | translate"></app-form-fields>

          </div>
          <div class="ui-g-4">
            <app-form-fields #soloBarcodeAttivatore data-testid="soloBarcodeAttivatore"
              [label]="formSchema.form.solo_barcode_attivatore.label[language]" [readOnly]="readOnly"
              (checkboxChanged)="onChangeSoloBarcodeAttivatore($event)" [(fieldModel)]="switch.soloBarcodeAttivatore"
              [disabled]="formSchema.form.solo_barcode_attivatore.disabled"
              [visible]="formSchema.form.solo_barcode_attivatore.visible" [type]="'checkbox'"></app-form-fields>
          </div>
          <div class="ui-g-8">
            <app-form-fields #soloBarcodeAttivatoreText data-testid="soloBarcodeAttivatoreText"
              [(fieldModel)]="fieldModel.barcodeManualCouponAttivatore" [showLabel]="false" [type]="'string'"
              *ngIf="soloBarcodeAttivatore.fieldModel"></app-form-fields>
            <app-form-fields class="barcodeCouponTitle" [readOnly]="readOnly"
              [fieldSchema]="formSchema.form.barcode_coupon_attivatore" *ngIf="!soloBarcodeAttivatore.fieldModel"
              #comboBarcodesAttivatore data-testid="comboBarcodesAttivatore" [optionLabel]="'barcode'"
              [(fieldModel)]="fieldModel.articoloCouponAttivatore.barcode" [type]="'dropdown'"
              [options]="comboBarcodesAttivatore" [placeholder]="'xxxxxxxxxxxxxxxxx'"></app-form-fields>
          </div>
        </div>
      </div>


      <div class="ui-g-12">

        <app-form-fields #switchLimitiEmissione data-testid="switchLimitiEmissione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.switch_limiti_emissione" (fieldModelChange)="onChangeLimitiEmissione($event)"
          [(fieldModel)]="switch.limitiEmissione"></app-form-fields>
      </div>
      <div class="ui-g ui-g-12" *ngIf="switch.limitiEmissione">
        <div class="ui-g-12">
          <div class="limiteEmissioneContainer">
            <app-form-fields [readOnly]="readOnly" (fieldModelChange)="onTotalCouponNumberChange($event)"
              [fieldSchema]="formSchema.form.num_max_emissioni_totali" #maxEmissioniTotali
              data-testid="maxEmissioniTotali" [(fieldModel)]="fieldModel.limitiEmissione.maxEmissioniTotali"
              [type]="'number'"></app-form-fields>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="limiteEmissioneContainer">
            <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.num_max_transazioni_emittenti_clienti"
              #maxTransazioniCliente data-testid="maxTransazioniCliente"
              [(fieldModel)]="fieldModel.limitiEmissione.maxTransazioniCliente" [type]="'number'"></app-form-fields>
          </div>
        </div>

        <!-- CAMBIAMENTO A SEGUITO DI CALL 02/04/2024 (vedi commenti issue KS-5417 e KS-5418) -->
        <!--
              <div class="ui-g-12">
                <div class="limiteEmissioneContainer" *ngIf="switch.limitiEmissione">
                  <app-form-fields #maxEmissioniClienteTransazioni [(fieldModel)]="fieldModel.limitiEmissione.maxEmissioniClienteTransazioni" [name]="'maxEmissioniClienteTransazioni'" [step]="1" [label]="'Numero massimo emissioni per cliente per transazione'" [required]="true" [type]="'number'" [minValue]="0"></app-form-fields>
                </div>
              </div>
            -->

        <!-- CAMBIAMENTO ENNESIMO A SEGUITO DI KS-6304 -->

        <div class="ui-g-12">
          <div class="limiteEmissioneContainer" *ngIf="switch.limitiEmissione">
            <app-form-fields [readOnly]="readOnly" [fieldSchema]="formSchema.form.num_max_emissioni_cliente"
              #maxEmissioniClienteTransazioni [(fieldModel)]="fieldModel.limitiEmissione.maxEmissioniCliente"
              [type]="'number'"></app-form-fields>
          </div>
        </div>


      </div>
    </div>
  </div>



  <!-- Gestione accumulatori -->
  <p-dialog *ngIf="show.modalAcmList && messageInstanceObject" [width]="1500" [height]="800"
    [(visible)]="show.modalAcmList" [responsive]="true" [header]="'campaign.search_accumulators_emission' | translate "
    showEffect="fade" [modal]="true">
    <app-campaign-3-search-accumulators #searchAccumulators [multipleselection]="true" [accumulatorList]="listAccumulatorModelEmission"
      [dateStart]="messageInstanceObject.startEmissionDate" [dateEnd]="messageInstanceObject.endEmissionDate"
      (acmSelected)="onAcmSelected($event)"></app-campaign-3-search-accumulators>


  </p-dialog>
  <!-- Gestione regole -->
  <p-dialog *ngIf="show.modalAcmListForRules && messageInstanceObject" [width]="1500" [height]="800"
    [(visible)]="show.modalAcmListForRules" [responsive]="true"
    [header]="'campaign.search_accumulators_emission' | translate " showEffect="fade" [modal]="true">

    <app-campaign-3-search-accumulators #searchAccumulatorsForRules [multipleselection]="false"
      [accumulatorList]="listAccumulatorModelEmissionForRules" [dateStart]="messageInstanceObject.startEmissionDate"
      [dateEnd]="messageInstanceObject.endEmissionDate"
      (acmSelected)="onAcmSelectedForRules($event)"></app-campaign-3-search-accumulators>


  </p-dialog>





  <p-dialog *ngIf="show.modalProductList" [width]="1500" [height]="800" [(visible)]="show.modalProductList"
    [responsive]="true" [header]=" 'campaign.search_article' | translate " showEffect="fade" [modal]="true">


    <!-- Bottoni Annulla e Conferma -->
    <div class="ui-dialog-footer fixed-buttons buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalArticoli()" type="button" class="k-generic-btn footer-btn"
        label="{{'common.cancel' | translate}}"></button>
      <div class="clear_fix"></div>
    </div>

<!-- // KS-7308 sdoppiato componente
    <app-campaign-3-search-product #searchProduct
      (productSelected)="onProductSelected($event)"
      [messageInstanceIdValue]="messageInstanceObject.id"></app-campaign-3-search-product> -->
   <app-campaign-3-search-product-barcode #searchProduct
      (productSelected)="onProductSelected($event)"
      [messageInstanceIdValue]="messageInstanceObject.id"></app-campaign-3-search-product-barcode>
  </p-dialog>



  <p-dialog *ngIf="show.modalProductListAttivatore" [width]="1500" [height]="800"
    [(visible)]="show.modalProductListAttivatore" [responsive]="true" [header]=" 'campaign.search_article' | translate "
    showEffect="fade" [modal]="true">

    <app-campaign-3-search-product-activator #searchProductAttivatore
      (productSelected)="onProductAttivatoreSelected($event)"></app-campaign-3-search-product-activator>

    <!-- Bottoni Annulla e Conferma -->
    <div class="ui-dialog-footer buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalArticoli()" type="button" class="k-generic-btn footer-btn"
        label="{{'common.cancel' | translate}}"></button>
      <div class="clear_fix"></div>
    </div>

  </p-dialog>




</div>


// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-emission-conditions/message-3-emission-conditions.component.html